// Framework imports
import React from "react";
import PropTypes from "prop-types";

class CustomSvgIcon extends React.Component {
  render() {
    const { name, width, height, stroke, vertAlign } = this.props;
    switch (name) {
      case "GrabCutIcon":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="71.337 278 32.666 34"
            style={{ isolation: "isolate", verticalAlign: vertAlign }}
            width={width}
            height={height}
          >
            <mask id="_mask_MjjndE998VThuTWR6sXZOZaDpVlW90eA">
              <path
                d=" M 98.857 280.738 C 92.762 277.793 81.511 284.526 79.848 285.855 C 77.596 287.652 75.733 289.156 74.337 290.805 C 72.944 292.465 72.04 294.378 72.001 296.628 C 71.971 298.624 72.587 300.798 73.808 303.397 C 75.826 307.664 80.163 310.67 84.798 311.878 C 89.568 312.316 93.483 311.692 96.857 308.065 C 100.638 303.997 103.96 298.299 103.999 292.129 C 104.006 291.119 104.274 283.591 98.857 280.738 Z "
                style={{
                  fillRule: "evenodd",
                  fill: "white",
                  stroke: "none",
                }}
              />
            </mask>
            <path
              d=" M 98.857 280.738 C 92.762 277.793 81.511 284.526 79.848 285.855 C 77.596 287.652 75.733 289.156 74.337 290.805 C 72.944 292.465 72.04 294.378 72.001 296.628 C 71.971 298.624 72.587 300.798 73.808 303.397 C 75.826 307.664 80.163 310.67 84.798 311.878 C 89.568 312.316 93.483 311.692 96.857 308.065 C 100.638 303.997 103.96 298.299 103.999 292.129 C 104.006 291.119 104.274 283.591 98.857 280.738 Z "
              style={{
                fillRule: "evenodd",
                fill: "none",
                mask: "url(#_mask_MjjndE998VThuTWR6sXZOZaDpVlW90eA)",
                vectorEffect: "non-scaling-stroke",
                strokeWidth: "3.316", //"4.182",
                stroke: "currentColor",
                strokeLinejoin: "miter",
                strokeLinecap: "square",
                strokeMiterlimit: "3",
              }}
              stroke={stroke}
            />
            <path
              d=" M 80.857 291.096 C 82.471 289.217 83.676 288.765 85.857 287.675 C 88.27 286.469 89.97 286 91.857 285.356"
              style={{
                fill: "none",
                vectorEffect: "non-scaling-stroke",
                strokeWidth: "1.5",
                stroke: "currentColor",
                strokeLinejoin: "miter",
                strokeLinecap: "round",
                strokeMiterlimit: "3",
              }}
              stroke={stroke}
            />
            <path
              d=" M 74.337 286 C 76.153 284.316 76.176 284.083 78.357 282.994 C 80.77 281.788 81.113 281.644 83 281"
              style={{
                fill: "none",
                vectorEffect: "non-scaling-stroke",
                strokeWidth: "1.5",
                stroke: "currentColor",
                strokeLinejoin: "miter",
                strokeLinecap: "round",
                strokeMiterlimit: "3",
              }}
              stroke={stroke}
            />
          </svg>
        );
      case "SAMIcon":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="71.337 278 32.666 34"
            style={{ isolation: "isolate", verticalAlign: vertAlign }}
            width={width}
            height={height}
          >
            <mask id="_mask_MjjndE998VThuTWR6sXZOZaDpVlW90eA">
              <path
                d=" M 98.857 280.738 C 92.762 277.793 81.511 284.526 79.848 285.855 C 77.596 287.652 75.733 289.156 74.337 290.805 C 72.944 292.465 72.04 294.378 72.001 296.628 C 71.971 298.624 72.587 300.798 73.808 303.397 C 75.826 307.664 80.163 310.67 84.798 311.878 C 89.568 312.316 93.483 311.692 96.857 308.065 C 100.638 303.997 103.96 298.299 103.999 292.129 C 104.006 291.119 104.274 283.591 98.857 280.738 Z "
                style={{
                  fillRule: "evenodd",
                  fill: "white",
                  stroke: "none",
                }}
              />
            </mask>
            <path
              d=" M 98.857 280.738 C 92.762 277.793 81.511 284.526 79.848 285.855 C 77.596 287.652 75.733 289.156 74.337 290.805 C 72.944 292.465 72.04 294.378 72.001 296.628 C 71.971 298.624 72.587 300.798 73.808 303.397 C 75.826 307.664 80.163 310.67 84.798 311.878 C 89.568 312.316 93.483 311.692 96.857 308.065 C 100.638 303.997 103.96 298.299 103.999 292.129 C 104.006 291.119 104.274 283.591 98.857 280.738 Z "
              style={{
                fillRule: "evenodd",
                fill: "none",
                mask: "url(#_mask_MjjndE998VThuTWR6sXZOZaDpVlW90eA)",
                vectorEffect: "non-scaling-stroke",
                strokeWidth: "3.316", //"4.182",
                stroke: "currentColor",
                strokeLinejoin: "miter",
                strokeLinecap: "square",
                strokeMiterlimit: "3",
              }}
              stroke={stroke}
            />
            <circle
              cx="77.5"
              cy="282.5"
              r="2"
              style={{
                fill: "currentColor",
                vectorEffect: "non-scaling-stroke",
                strokeWidth: "1.5",
                stroke: "currentColor",
                strokeLinejoin: "miter",
                strokeLinecap: "round",
                strokeMiterlimit: "3",
              }}
              stroke={stroke}
            />
            <circle
              cx="84"
              cy="293"
              r="2"
              style={{
                fill: "currentColor",
                vectorEffect: "non-scaling-stroke",
                strokeWidth: "1.5",
                stroke: "currentColor",
                strokeLinejoin: "miter",
                strokeLinecap: "round",
                strokeMiterlimit: "3",
              }}
              stroke={stroke}
            />
          </svg>
        );
      case "ResultsIcon":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            style={{ verticalAlign: vertAlign }}
            width={width}
            height={height}
          >
            <path
              fill="currentColor"
              d="M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"
            ></path>
          </svg>
        );
      case "HeatmapIcon":
        return (
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 1000 1000"
            style={{ verticalAlign: vertAlign }}
            width={width}
            height={height}
          >
            <g>
              <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
                <path
                  fill="currentColor"
                  d="M224.5,5006.8c-21.1-9.6-55.5-36.4-76.6-59.4c-38.3-42.1-38.3-72.8-44-4886L100-4782.4l4843.8,3.8l4843.8,5.7l49.8,46c65.1,61.3,78.5,137.9,38.3,222.2c-17.2,36.4-42.1,74.7-53.7,82.4c-11.5,7.7-2114.5,17.2-4675.3,23l-4654.2,9.6l-9.6,4644.6c-9.6,5092.8,0,4707.8-122.6,4750C295.4,5027.9,276.2,5027.9,224.5,5006.8z"
                />
                <path
                  fill="currentColor"
                  d="M3915.3,4393.9c-316-86.2-599.5-319.9-745.1-614.8c-93.8-191.5-120.7-310.3-120.7-522.9c1.9-450.1,245.2-844.7,645.5-1045.8c174.3-86.2,316-118.8,522.9-118.8c208.8,0,360.1,34.5,526.7,120.7c400.3,204.9,641.6,595.7,641.6,1036.2c0,218.3-26.8,335.2-116.8,524.8c-128.3,268.1-388.8,498-687.6,603.3C4420.9,4434.1,4097.3,4441.8,3915.3,4393.9z M4396,4018.5c160.9-42.1,256.7-95.8,371.6-212.6c423.3-423.3,237.5-1128.1-344.8-1300.5c-536.3-159-1086,348.6-971.1,900.2c61.3,296.9,283.5,532.5,574.6,611C4164.3,4053,4262,4053,4396,4018.5z"
                />
                <path
                  fill="currentColor"
                  d="M1724.2,4028.1c-145.6-24.9-295-105.3-409.9-218.3c-363.9-365.8-279.6-978.7,172.4-1235.4c421.4-239.4,978.7-13.4,1122.4,453.9c139.8,450.1-141.7,909.8-612.9,999.8C1883.2,4049.1,1854.4,4049.1,1724.2,4028.1z M2024.9,3608.6c218.3-101.5,291.1-360.1,160.9-570.8c-78.5-126.4-260.5-191.5-423.3-149.4c-340.9,88.1-385,572.7-63.2,720.2C1797,3654.6,1927.2,3654.6,2024.9,3608.6z"
                />
                <path
                  fill="currentColor"
                  d="M6420.5,4026.1c-331.3-67-597.6-365.8-626.3-701c-30.6-363.9,197.3-702.9,544-810.2c293-90,582.2-15.3,792.9,204.9c114.9,120.7,164.7,212.6,201.1,367.7c86.2,369.7-124.5,766.1-478.8,900.2C6732.7,4031.9,6535.4,4051,6420.5,4026.1z M6723.1,3616.3c145.6-61.3,231.8-195.4,233.7-360.1c1.9-379.2-494.2-524.8-710.6-208.8c-38.3,57.5-46,91.9-46,216.4c0,136,3.8,153.2,59.4,222.2C6372.6,3627.8,6564.2,3681.4,6723.1,3616.3z"
                />
                <path
                  fill="currentColor"
                  d="M8780.2,4028.1c-210.7-44-425.2-195.4-528.6-373.5c-203-344.8-101.5-808.3,226-1034.3c480.7-329.4,1126.2-51.7,1220,524.8c55.6,352.4-153.2,716.3-486.5,840.8C9090.5,4031.9,8891.3,4051,8780.2,4028.1z M9079,3616.3c266.2-113,314.1-471.2,90-656.9c-289.2-237.5-708.7,36.4-612.9,402.2C8611.6,3581.8,8866.4,3704.4,9079,3616.3z"
                />
                <path
                  fill="currentColor"
                  d="M6409,1480.7c-469.2-72.8-856.1-419.5-974.9-871.5c-42.1-159-38.3-446.3,5.7-605.2c109.2-390.7,448.2-722.1,838.9-821.7c411.8-105.3,823.6,9.6,1126.2,316c226,229.8,337.1,498,337.1,814c-1.9,444.4-226,825.5-618.7,1038.1C6920.4,1461.5,6627.4,1515.2,6409,1480.7z M6780.6,1068.9C7089,977,7318.8,703.1,7351.3,389c40.2-396.5-254.7-773.8-658.8-844.7c-235.6-42.1-488.4,44.1-670.4,226c-369.7,367.7-283.5,967.2,176.2,1231.5c55.5,30.6,134.1,65.1,176.2,74.7C6493.3,1103.4,6673.3,1099.6,6780.6,1068.9z"
                />
                <path
                  fill="currentColor"
                  d="M1632.2,1061.2c-365.8-116.8-597.6-484.6-538.2-858.1c111.1-716.3,1040-909.8,1432.7-298.8c193.4,304.5,149.4,702.9-109.2,963.4C2208.8,1074.7,1908,1149.4,1632.2,1061.2z M2067,645.6c195.4-113,243.2-394.6,97.7-572.7c-182-220.3-530.5-180-649.3,76.6C1354.5,496.2,1733.8,837.2,2067,645.6z"
                />
                <path
                  fill="currentColor"
                  d="M8707.4,1068.9c-134.1-42.1-231.8-101.5-333.3-201.1c-314.1-316-306.5-814,21.1-1120.4c306.4-287.3,781.5-279.6,1080.2,19.2c419.5,421.4,237.5,1131.9-333.3,1300.5C9019.6,1103.4,8818.5,1103.4,8707.4,1068.9z M9038.7,685.8c245.2-72.8,352.4-379.2,204.9-588C9056-170.3,8636.5-99.4,8556.1,212.8c-57.5,218.4,68.9,432.9,285.4,482.7C8929.6,716.5,8933.4,716.5,9038.7,685.8z"
                />
                <path
                  fill="currentColor"
                  d="M3955.5-1478.4c-306.4-67-634-321.8-775.7-605.2c-95.8-187.7-130.2-335.2-130.2-540.1c0-519.1,316-950,823.6-1126.2c172.4-59.4,507.6-61.3,685.7-1.9c352.4,114.9,649.3,402.2,773.8,750.8c49.8,134.1,67,453.9,36.4,616.7c-13.4,67-59.4,193.4-103.4,283.5C5028.1-1622.1,4484.1-1363.5,3955.5-1478.4z M4430.5-1873c111.1-26.8,249-113,348.6-214.5c101.5-105.3,160.9-206.9,197.3-348.6c93.8-350.5-91.9-733.6-432.9-898.3c-114.9-55.5-139.8-59.4-325.6-59.4c-189.6,0-210.7,3.8-327.5,61.3c-490.3,241.3-605.2,863.8-229.8,1248.8C3861.7-1876.8,4143.2-1800.2,4430.5-1873z"
                />
                <path
                  fill="currentColor"
                  d="M8795.5-1654.7c-197.3-23-409.9-132.2-566.9-289.2c-295-295-362-756.6-164.7-1143.4c59.4-118.8,272-333.3,386.9-392.6c247.1-126.4,522.9-155.1,766.1-78.5c589.9,185.8,860,871.5,559.3,1415.4c-109.2,197.3-346.7,386.9-574.6,455.9C9103.9-1658.5,8897-1641.2,8795.5-1654.7z M9169-2099c214.5-101.5,321.8-264.3,331.3-503.7c7.7-124.5,0-162.8-38.3-249c-65.1-143.6-151.3-233.7-279.6-296.9c-145.6-70.9-348.6-74.7-492.2-9.6c-379.2,174.3-463.5,668.4-160.9,957.7C8697.8-2037.7,8956.4-1997.5,9169-2099z"
                />
                <path
                  fill="currentColor"
                  d="M1795-1846.2c-555.4-65.1-873.4-639.7-626.3-1131.9c185.8-371.6,647.4-530.5,1024.7-352.4c302.6,139.8,475,442.5,448.2,777.6c-26.8,312.2-266.2,605.3-559.3,678C1980.8-1850,1865.9-1838.5,1795-1846.2z M2011.5-2263.7c346.7-145.6,308.4-639.7-59.4-739.3c-304.5-82.4-574.6,258.6-434.8,547.8C1607.3-2271.4,1823.8-2187.1,2011.5-2263.7z"
                />
                <path
                  fill="currentColor"
                  d="M6439.7-1853.9c-360.1-59.4-649.3-400.3-651.2-764.2c0-105.3,44.1-281.6,95.8-383.1c59.4-116.8,222.2-266.2,362-333.3c116.8-55.5,141.7-59.4,327.5-59.4c185.8,0,210.7,3.8,327.5,59.4c226,107.3,394.6,327.5,440.5,572.7C7437.5-2236.9,6970.2-1765.7,6439.7-1853.9z M6790.2-2304c116.8-80.4,170.5-197.3,162.8-344.7c-13.4-214.5-166.6-360.1-381.1-362c-415.6,0-532.5,574.6-151.3,747C6525.9-2217.8,6690.6-2235,6790.2-2304z"
                />
              </g>
            </g>
          </svg>
        );
      case "ResetZoomIcon":
        return (
          <svg
            className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root"
            focusable="false"
            aria-hidden="true"
            viewBox="0 0 24 24"
            data-testid="ZoomInIcon"
          >
            <rect
              x="8"
              y="8"
              width="3"
              height="3"
              style={{
                fill: "none",
                strokeWidth: 1,
                stroke: "currentColor",
              }}
            />
            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path>
          </svg>
        );
      case "InferenceIcon":
        return (
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="connectdevelop"
            className="svg-inline--fa fa-connectdevelop fa-w-18"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 576 512"
            style={{ verticalAlign: vertAlign }}
            width={width}
            height={height}
          >
            <path
              fill="currentColor"
              d="M550.5 241l-50.089-86.786c1.071-2.142 1.875-4.553 1.875-7.232 0-8.036-6.696-14.733-14.732-15.001l-55.447-95.893c.536-1.607 1.071-3.214 1.071-4.821 0-8.571-6.964-15.268-15.268-15.268-4.821 0-8.839 2.143-11.786 5.625H299.518C296.839 18.143 292.821 16 288 16s-8.839 2.143-11.518 5.625H170.411C167.464 18.143 163.447 16 158.625 16c-8.303 0-15.268 6.696-15.268 15.268 0 1.607.536 3.482 1.072 4.821l-55.983 97.233c-5.356 2.41-9.107 7.5-9.107 13.661 0 .535.268 1.071.268 1.607l-53.304 92.143c-7.232 1.339-12.59 7.5-12.59 15 0 7.232 5.089 13.393 12.054 15l55.179 95.358c-.536 1.607-.804 2.946-.804 4.821 0 7.232 5.089 13.393 12.054 14.732l51.697 89.732c-.536 1.607-1.071 3.482-1.071 5.357 0 8.571 6.964 15.268 15.268 15.268 4.821 0 8.839-2.143 11.518-5.357h106.875C279.161 493.857 283.447 496 288 496s8.839-2.143 11.518-5.357h107.143c2.678 2.946 6.696 4.821 10.982 4.821 8.571 0 15.268-6.964 15.268-15.268 0-1.607-.267-2.946-.803-4.285l51.697-90.268c6.964-1.339 12.054-7.5 12.054-14.732 0-1.607-.268-3.214-.804-4.821l54.911-95.358c6.964-1.339 12.322-7.5 12.322-15-.002-7.232-5.092-13.393-11.788-14.732zM153.535 450.732l-43.66-75.803h43.66v75.803zm0-83.839h-43.66c-.268-1.071-.804-2.142-1.339-3.214l44.999-47.41v50.624zm0-62.411l-50.357 53.304c-1.339-.536-2.679-1.34-4.018-1.607L43.447 259.75c.535-1.339.535-2.679.535-4.018s0-2.41-.268-3.482l51.965-90c2.679-.268 5.357-1.072 7.768-2.679l50.089 51.965v92.946zm0-102.322l-45.803-47.41c1.339-2.143 2.143-4.821 2.143-7.767 0-.268-.268-.804-.268-1.072l43.928-15.804v72.053zm0-80.625l-43.66 15.804 43.66-75.536v59.732zm326.519 39.108l.804 1.339L445.5 329.125l-63.75-67.232 98.036-101.518.268.268zM291.75 355.107l11.518 11.786H280.5l11.25-11.786zm-.268-11.25l-83.303-85.446 79.553-84.375 83.036 87.589-79.286 82.232zm5.357 5.893l79.286-82.232 67.5 71.25-5.892 28.125H313.714l-16.875-17.143zM410.411 44.393c1.071.536 2.142 1.072 3.482 1.34l57.857 100.714v.536c0 2.946.803 5.624 2.143 7.767L376.393 256l-83.035-87.589L410.411 44.393zm-9.107-2.143L287.732 162.518l-57.054-60.268 166.339-60h4.287zm-123.483 0c2.678 2.678 6.16 4.285 10.179 4.285s7.5-1.607 10.179-4.285h75L224.786 95.821 173.893 42.25h103.928zm-116.249 5.625l1.071-2.142a33.834 33.834 0 0 0 2.679-.804l51.161 53.84-54.911 19.821V47.875zm0 79.286l60.803-21.964 59.732 63.214-79.553 84.107-40.982-42.053v-83.304zm0 92.678L198 257.607l-36.428 38.304v-76.072zm0 87.858l42.053-44.464 82.768 85.982-17.143 17.678H161.572v-59.196zm6.964 162.053c-1.607-1.607-3.482-2.678-5.893-3.482l-1.071-1.607v-89.732h99.91l-91.607 94.821h-1.339zm129.911 0c-2.679-2.41-6.428-4.285-10.447-4.285s-7.767 1.875-10.447 4.285h-96.429l91.607-94.821h38.304l91.607 94.821H298.447zm120-11.786l-4.286 7.5c-1.339.268-2.41.803-3.482 1.339l-89.196-91.875h114.376l-17.412 83.036zm12.856-22.232l12.858-60.803h21.964l-34.822 60.803zm34.822-68.839h-20.357l4.553-21.16 17.143 18.214c-.535.803-1.071 1.874-1.339 2.946zm66.161-107.411l-55.447 96.697c-1.339.535-2.679 1.071-4.018 1.874l-20.625-21.964 34.554-163.928 45.803 79.286c-.267 1.339-.803 2.678-.803 4.285 0 1.339.268 2.411.536 3.75z"
            ></path>
          </svg>
        );
      case "AILearningIcon":
        return (
          <svg viewBox="0 0 120 150" width={width} height={height}>
            <g>
              <path
                fill="currentColor"
                d="M64.94,8.92c2.03,3.52,3.42,12.25,4.15,23.81h12.97V20.46c-0.28-0.13-0.55-0.28-0.81-0.45c-0.49-0.31-0.94-0.67-1.33-1.06 l-0.05-0.05c-0.69-0.69-1.24-1.52-1.62-2.44c-0.38-0.91-0.59-1.91-0.59-2.96c0-1.04,0.21-2.03,0.59-2.95 c0.39-0.95,0.97-1.8,1.67-2.51c0.71-0.71,1.56-1.28,2.51-1.67c0.91-0.38,1.91-0.59,2.95-0.59c1.04,0,2.03,0.21,2.95,0.59 c0.95,0.39,1.8,0.97,2.51,1.67c0.71,0.71,1.28,1.56,1.67,2.5l0.02,0.06c0.36,0.9,0.56,1.88,0.56,2.89c0,1.04-0.21,2.03-0.59,2.95 c-0.39,0.95-0.97,1.8-1.67,2.51l-0.06,0.06c-0.35,0.34-0.74,0.66-1.15,0.93c-0.22,0.15-0.45,0.28-0.69,0.41v15.84 c0,0.95-0.39,1.81-1.01,2.43c-0.62,0.62-1.48,1.01-2.43,1.01H69.43c0.12,3.29,0.2,6.75,0.23,10.32h30.44 c0.13-0.26,0.27-0.51,0.42-0.75l0.04-0.05c0.29-0.45,0.63-0.86,0.99-1.22c0.71-0.71,1.56-1.28,2.51-1.67l0.06-0.02 c0.9-0.36,1.88-0.57,2.89-0.57c1.04,0,2.03,0.21,2.95,0.59c0.95,0.39,1.8,0.97,2.51,1.67c0.71,0.71,1.28,1.56,1.67,2.51 c0.38,0.92,0.59,1.91,0.59,2.95c0,1.04-0.21,2.03-0.59,2.95c-0.39,0.95-0.97,1.8-1.67,2.51c-0.71,0.71-1.56,1.28-2.51,1.67 l-0.06,0.02c-0.9,0.36-1.88,0.56-2.89,0.56c-1.04,0-2.04-0.21-2.95-0.59c-0.94-0.39-1.79-0.96-2.51-1.67 c-0.38-0.38-0.72-0.8-1.02-1.27c-0.16-0.24-0.3-0.49-0.43-0.75H69.67c-0.03,3.9-0.11,7.89-0.24,11.95h37.21 c0.95,0,1.81,0.39,2.43,1.01c0.62,0.62,1.01,1.48,1.01,2.43v25.53c0.33,0.14,0.64,0.3,0.94,0.48c0.54,0.32,1.03,0.71,1.47,1.15 c0.71,0.71,1.28,1.56,1.67,2.51l0.02,0.06c0.36,0.9,0.57,1.88,0.57,2.89c0,1.04-0.21,2.03-0.59,2.95c-0.39,0.95-0.97,1.8-1.67,2.51 c-0.71,0.71-1.56,1.28-2.51,1.67c-0.91,0.38-1.91,0.59-2.95,0.59c-1.04,0-2.03-0.21-2.95-0.59c-0.95-0.39-1.8-0.97-2.51-1.67 c-0.71-0.71-1.28-1.56-1.67-2.51c-0.38-0.91-0.59-1.91-0.59-2.95c0-1.04,0.21-2.04,0.59-2.95c0.39-0.95,0.97-1.8,1.67-2.51 c0.32-0.32,0.68-0.62,1.06-0.89c0.18-0.13,0.37-0.25,0.57-0.36V75.66H69.16c-0.15,3.24-0.33,6.49-0.55,9.73h11.04 c0.95,0,1.81,0.39,2.43,1.01c0.62,0.62,1.01,1.48,1.01,2.43v13.66c0.25,0.13,0.48,0.27,0.72,0.42c0.46,0.3,0.87,0.64,1.24,1.01 l0.06,0.06c0.68,0.7,1.24,1.53,1.62,2.45c0.38,0.91,0.59,1.91,0.59,2.95c0,1.04-0.21,2.04-0.59,2.95l-0.03,0.06 c-0.39,0.93-0.96,1.76-1.65,2.45l-0.05,0.05c-0.7,0.69-1.53,1.25-2.44,1.63c-0.91,0.38-1.92,0.59-2.96,0.59 c-1.04,0-2.03-0.21-2.95-0.59c-0.95-0.39-1.8-0.97-2.51-1.67l-0.06-0.06c-0.68-0.7-1.24-1.53-1.62-2.45 c-0.38-0.92-0.59-1.91-0.59-2.95s0.21-2.03,0.59-2.95c0.39-0.95,0.96-1.8,1.67-2.51l0,0c0.39-0.39,0.83-0.74,1.29-1.04 c0.25-0.16,0.51-0.31,0.78-0.44V92.28H68.1c-0.11,1.37-0.23,2.74-0.35,4.1c-0.16,1.76-0.67,5.01-0.34,6.62 c0.88,4.27-2.97,17.15-14.29,19.52c-5.58,1.16-11.35-0.55-15.7-3.95c-3.48-2.71-6.09-6.52-7.03-10.83 c-1.82-0.07-3.67-0.44-5.47-1.04c-3.98-1.34-7.81-3.95-10.8-7.41c-3.01-3.47-5.19-7.83-5.88-12.68c-0.35-2.53-0.3-5.17,0.26-7.89 c-1.95-1.77-3.63-3.76-4.96-5.93C1.22,69.08-0.05,64.9,0,60.6c0.05-4.33,1.43-8.72,4.42-12.8c1.74-2.37,4.03-4.63,6.93-6.7 c-0.03-0.79-0.03-1.58-0.01-2.36c0.23-6.32,2.56-11.88,5.96-16.03c3.52-4.3,8.23-7.11,13.07-7.8h0.02 c0.17-0.71,0.37-1.41,0.63-2.09c1.56-4.23,4.77-7.83,8.7-10.12c3.96-2.3,8.71-3.32,13.34-2.36C57.51,1.28,61.75,3.94,64.94,8.92 L64.94,8.92L64.94,8.92z M30.77,99.21c1.64-5.16,5.97-10.31,14.14-14.48c2.04-1.03,4.52-0.23,5.57,1.8 c1.03,2.04,0.23,4.52-1.8,5.57c-7.57,3.87-10.42,8.31-10.42,12.18c0,3.02,1.72,5.84,4.22,7.8c2.54,1.97,5.82,3,8.92,2.36 c3.86-0.8,7.58-4.37,9.51-12.15V20.49c-1.93-7.72-5.65-11.27-9.5-12.07c-2.54-0.53-5.24,0.07-7.54,1.42 c-2.33,1.35-4.2,3.43-5.09,5.83c-1.18,3.2-0.48,7.13,3.52,10.83c1.66,1.55,1.77,4.14,0.22,5.8c-1.55,1.66-4.14,1.77-5.8,0.22 c-3.11-2.88-5.03-5.94-5.99-8.99c-2.45,0.59-4.87,2.21-6.83,4.59c-2.29,2.79-3.86,6.57-4.02,10.91c-0.04,1.15,0.02,2.37,0.19,3.62 h-0.01c0.22,1.62-0.5,3.3-1.98,4.21c-3,1.84-5.21,3.87-6.76,5.98c-1.88,2.56-2.74,5.25-2.77,7.84c-0.03,2.63,0.78,5.25,2.23,7.6 c1.23,1.99,2.91,3.81,4.96,5.33c1.54,1.06,2.26,3.04,1.63,4.89c-0.81,2.4-0.99,4.73-0.68,6.9c0.44,3.12,1.89,5.97,3.87,8.26 c1.99,2.3,4.51,4.02,7.09,4.9C28.69,98.96,29.74,99.16,30.77,99.21L30.77,99.21L30.77,99.21z M31.71,41.1 c1.62-1.59,4.22-1.57,5.82,0.05c1.59,1.62,1.57,4.22-0.05,5.82c-3.53,3.48-5.37,7.96-5.57,12.54c-0.19,4.72,1.34,9.58,4.56,13.57 c1.43,1.77,1.14,4.36-0.63,5.79c-1.77,1.43-4.36,1.14-5.79-0.63c-4.51-5.59-6.65-12.39-6.38-19.06 C23.96,52.56,26.62,46.1,31.71,41.1L31.71,41.1L31.71,41.1z"
              />
            </g>
          </svg>
        );
    }
  }
}

CustomSvgIcon.propTypes = {
  name: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  stroke: PropTypes.string,
  vertAlign: PropTypes.string,
};

export default CustomSvgIcon;
